module.exports = __webpack_public_path__ + "img/neck.b3459f4c.jpg";